import React from 'react';
import { SportsDisplayedContext } from '../../context/sportsDisplayed';
import { SportsDisplayedType } from '../../@types/sportsDisplayedType';
import { Convert, ITournamentRecap } from '../../interfaces/ITournamentRecap';
import TournamentRecap from '../../components/tournamentRecap/tournamentRecap';
import { GetFetchData } from '../../utility/fetch';

import '../../global.styles.scss';
import '../views.styles.scss';
import './blog.styles.scss';
import Tournament from '../../components/tournament/tournament';
import { ITournament } from '../../interfaces/ITournament';

interface IProps{}
interface IState{
    tournamentRecap: ITournamentRecap[];
}

export default class Blog extends React.Component<IProps, IState>{
    static contextType = SportsDisplayedContext;

    constructor (props: any){
        super(props);
       
        this.setTournamentData = this.setTournamentData.bind(this);
    }

    setTournamentData( data: string ){
        let tournamentData = Convert.toITournamentRecap( data );
        this.setState({ tournamentRecap: tournamentData });
    }

    componentDidMount(){
        GetFetchData( 'tournamentRecap', 'data/tournamentRecap.json', this.setTournamentData );
    }

    render(){
        const { isBaseballSelected, isSoftballSelected } = (this.context as SportsDisplayedType);

        const findTournamentYear = ( year: number ): ITournamentRecap | undefined => {
            let lsTournamentRecap = localStorage.getItem('tournamentRecap');
    
            if ( lsTournamentRecap !== undefined && lsTournamentRecap !== null ){
                let recapYears = Convert.toITournamentRecap( lsTournamentRecap );
                let tournamentYear: ITournamentRecap | undefined = recapYears.find( ry => ry.Year === year );
    
                return tournamentYear;
            } else {
                return undefined;
            }
        }

        const tournamentRecap2026: ITournamentRecap | undefined = findTournamentYear( 2026 );
        const tournamentRecap2025: ITournamentRecap | undefined = findTournamentYear( 2025 );
        const tournamentRecap2024: ITournamentRecap | undefined = findTournamentYear( 2024 );
        const tournamentRecap2023: ITournamentRecap | undefined = findTournamentYear( 2023 );
        const tournamentRecap2022: ITournamentRecap | undefined = findTournamentYear( 2022 );
        const tournamentRecap2021: ITournamentRecap | undefined = findTournamentYear( 2021 );
        const tournamentRecap2020: ITournamentRecap | undefined = findTournamentYear( 2020 );
        const tournamentRecap2019: ITournamentRecap | undefined = findTournamentYear( 2019 );

        const May2026Tournment: ITournament = {
            Title: 'Spring Tournament',
            Description: '',
            StartDate: { Date: 28, Month: 'April', Ordinal: 'th' },
            EndDate: { Date: 2, Month: 'May', Ordinal: 'nd' },
            Bracket: [
                {
                    Age: '10u',
                    BracketURL: 'https://docs.google.com/spreadsheets/d/1zLCRLB1vmHeuN6nTIPJG-tz10usFv73N_GEnPfuHb3I/edit?usp=sharing',
                    RulesURL: 'https://docs.google.com/document/d/1JtB9wkxi1YH0hnPdwVD2qwTlFSdJ8ylw5VniPtvCyns/edit?usp=drive_link',
                    Results: ['LVC', 'Tremont']
                },
                  {
                    Age: '12u',
                    BracketURL: 'https://docs.google.com/spreadsheets/d/15CsINJCpHclAahGRGHNGVheIxr8jQJ3_udcmk68wFbQ/edit?usp=sharing',
                    RulesURL: 'https://docs.google.com/document/d/1rTctvjuz8wKC9-bixo4CVUVP73WfoAB5TzmB_4PnXuk/edit?usp=sharing',
                    Results: ['1:9 Legacy', 'USA Prime Illinois Elliott']
                },
                {
                    Age: '13u',
                    BracketURL: 'https://docs.google.com/spreadsheets/d/1WdgHxgpZ1PZS8d2mCuDUCrV12P4KW6jlppUnaINYg7Y/edit?usp=sharing',
                    RulesURL: 'https://docs.google.com/document/d/1g0n8zoCrIcXazWbe4j-eMrLM473RigvoZ_lUHB3gFzY/edit?usp=sharing',
                    Results: ['TCC Blue', 'TCC White']
                },
                {
                    Age: '14u',
                    BracketURL: 'https://docs.google.com/spreadsheets/d/19Jd3dJcUvhlQ7Ae2TgN0JuaLW3RbgJvL0YxAGQKOD78/edit?usp=sharing',
                    RulesURL: 'https://docs.google.com/document/d/1E7JirQxJHTCdvIkJVrISKIVeLb3x-TlcS319XbT9MWI/edit?usp=sharing',
                    Results: ['OPBA', 'USA Prime Illinois Bruso']
                }
            ],
            Location: [
                {
                    Name: 'Central Junior High School',
                    MapsURL: 'https://www.google.com/maps/place/Central+Junior+High+School/@40.6642753,-89.5722625,19z/data=!4m5!3m4!1s0x880a5847d32fc4bf:0x7ce04b8d52c56a7c!8m2!3d40.6643549!4d-89.5717186',
                    City: 'East Peoria'
                },
                {
                    Name: 'Fondulac/Veterans Park',
                    City: 'East Peoria',
                    MapsURL: 'https://www.google.com/maps/place/Fondulac+Park,+East+Peoria,+IL+61611/@40.6576654,-89.5713119,17z/data=!3m1!4b1!4m2!3m1!1s0x880a58411a4da60f:0x7ef57a0ff5b244cf',
                    Notes: 'Turf batters box and mounds. METAL CLEATS ARE PROHIBITED!'
                },
                {
                    Name: 'Park District Sports Complex',
                    City: 'Pekin',
                    MapsURL: 'https://www.google.com/maps/place/Pekin+Park+Dist+Sports+Complex/@40.5525339,-89.6557469,17z/data=!3m1!4b1!4m5!3m4!1s0x880af477fff7ce11:0x94e9835b38fbcb06!8m2!3d40.5525341!4d-89.6535534'
                }
            ],
            Note: [
                'No open batting cages. Hitting into fence is prohibited.',
                'We ask coaches to turn in 3 game balls prior to your first game.'
            ]

        }

        return (
            <div className={`content-view blog ${ isBaseballSelected() ? 'showBaseball' : '' } ${ isSoftballSelected() ? 'showSoftball' : '' } `}>
               
                {/* <Tournament {...May2026Tournment }/> */}
                <article>
                    <header>Spiritwear</header>
                    
                    <p>USA Prime Illinois appearal is now available via <a href='https://bsnteamsports.com/shop/TSZaKT66Bg' target='_blank' rel='noreferrer'> BSN</a>.</p>  
                    <p>This is a traditional web store that doesn't have ordering windows, allowing you to purchase at your convenience.</p>

                </article>
                <TournamentRecap tournamentRecap={ tournamentRecap2026 }></TournamentRecap>
                
                {/* <article>
                    <header>Midwest Gamblers Is Now USA Prime Illinois!</header>
                    <img src='i/logo.png' alt='USA Prime logo' className='float-start' />
                    <p>Starting with the 2024 season, Midwest Gamblers will be joining the USA Prime national baseball program!</p>
                    <blockquote>"USA Prime brings a fantastic platform to the region to develop young players into leaders and ball players. I am excited to partner with USA Prime in Peoria to connect young players with the level of baseball that fits their skill set and to grow these players in all areas." ~ David Hidden.</blockquote>
                    <p>Established in 2017, USA Prime aims to prepare, develop, and mentor athletes to achieve their goals in baseball and ultimately reach their full potential.</p>
                </article> */}

                
                <TournamentRecap tournamentRecap={ tournamentRecap2025 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2024 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2023 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2022 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2021 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2020 }></TournamentRecap>
                <TournamentRecap tournamentRecap={ tournamentRecap2019 }></TournamentRecap>
            </div>
        );
    } 
}